"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSendButton = void 0;
var react_1 = __importDefault(require("react"));
var FormSendButton_module_scss_1 = __importDefault(require("./FormSendButton.module.scss"));
var FormSendButton = function (props) {
    var textContent = props.textContent;
    return (react_1.default.createElement("input", { className: FormSendButton_module_scss_1.default.form_send_button, type: "submit", value: textContent, onClick: function () {
            console.log('submit form click');
        } }));
};
exports.FormSendButton = FormSendButton;
